import React, {useState} from 'react'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import WizButton from '../../../../components/button/WizButton'

interface IProps {
    className?: string
    onClick?: (e: string) => void
}

const RecommendPostSearchContainer: React.FC<IProps> = ({className, onClick}) => {
    const [inputText, setInputText] = useState('')

    return (
        <div className={`flex gap-[10px] w-full justify-end ${className}`}>
            <UnderLineInput
                type={'text'}
                inputClassName={'h-full'}
                value={inputText}
                onChanged={(e: string) => setInputText(e)}
                onEnterKeyPress={() => onClick(inputText)}
            />
            <WizButton
                text={'Reset'}
                className={'text-white'}
                type={'blue'}
                onClick={() => {
                    onClick('')
                    setInputText('')
                }}
            />
            <WizButton
                text={'Search'}
                onClick={() => {
                    onClick(inputText)
                }}
            />
        </div>
    )
}

export default RecommendPostSearchContainer
